/* * 本页面为冷藏车监测点新增和冷藏车监测点修改界面 *
通过pageType字段来区分：1新增，2修改 * */
<template>
  <div ref="pageView" class="page-view container-view">
    <!-- title -->
    <section class="title-section fixed-view">
      <e6-title>
        {{ pageTitle }}
        <template slot="breadcrumb">
          <e6-breadcrumb :breadcrumbs="breadcrumbs"></e6-breadcrumb>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- content -->
    <section
      class="content-section"
      :style="{ height: resizeViewHeight + 'px' }"
    >
      <div class="form-wrapper">
        <e6-form-extend
          class="e6-from--column-2"
          ref="formExtend"
          :formExtend="formExtend"
          :inline="true"
          label-width="200px"
          :submitLoadingState="loadingState"
          @submitForm="handleSubmitForm"
          @resetForm="handleResetForm"
        >
          <template slot-scope="slotForms">
            <el-form-item
              v-if="pageType == 1"
              label="所属车辆"
              prop="forms.vehicleId"
              ref="vehicleIdElement"
              :rules="[
                {
                  required: true,
                  message: '请选择车辆',
                  trigger: 'change'
                }
              ]"
            >
              <e6Select
                :dataList="vehicleTreeList"
                :filterable="true"
                slotTemplate="tree"
                :issingleleaf="true"
                ref="vehicleTreeSelect"
                :placeholder="'所属车辆'"
                widthData="300px"
                @multipleSelect="handleSelectOrganization"
              ></e6Select>
              <span class="linkSpan"
                ><router-link
                  v-if="$GLOBAL_CONFIG.vehicleLabel.isShowAddVehicleButton"
                  :to="{
                    path: '/baseVehicleEdit'
                  }"
                  >新增车辆</router-link
                ></span
              >
            </el-form-item>

            <el-form-item
              v-if="pageType == 2"
              label="所属车辆"
              prop="forms.vehicleId"
              ref="vehicleTreeSelect"
              :rules="[
                {
                  required: true,
                  message: '请选择车辆',
                  trigger: 'blur,change'
                }
              ]"
            >
              <e6Select
                disabled
                :dataList="vehicleTreeList"
                :filterable="true"
                slotTemplate="tree"
                :issingleleaf="true"
                ref="vehicleSelect"
                :placeholder="'所属车辆'"
                widthData="300px"
                @multipleSelect="handleSelectOrganization"
              ></e6Select>
              <!-- <span class="linkSpan"
                ><router-link
                  :to="{
                    path: '/baseVehicleEdit'
                  }"
                  >新增车辆</router-link
                ></span
              > -->
            </el-form-item>

            <el-form-item
              label="监测点名称"
              prop="forms.labelName"
              :rules="[
                {
                  required: true,
                  message: '请输入监测点名称',
                  trigger: 'blur'
                },
                { validator: CheckComparyNameLength, trigger: 'blur' }
              ]"
            >
              <el-input
                v-model="slotForms.forms.labelName"
                placeholder="监测点名称"
                clearable
                @blur="checkLabelName"
              ></el-input>

              <div :class="{ alarmColor: labelNameAlarmFlag }">
                {{ labelNameMessage }}
              </div>
            </el-form-item>
            <el-form-item
              v-if="pageType == 1"
              label="监测点唯一标识码"
              prop="forms.uuid"
              :rules="[
                {
                  required: true,
                  message: '请输入监测点唯一标识码',
                  trigger: 'blur'
                },
                { validator: CheckComparyNameLength, trigger: 'blur' }
              ]"
            >
              <el-input
                v-model="slotForms.forms.uuid"
                placeholder="监测点唯一标识码"
                clearable
                @blur="checkLabelUuid"
              ></el-input>
              <div :class="{ alarmColor: labelUuidAlarmFlag }">
                {{ labelUuidMessage }}
              </div>
            </el-form-item>
            <el-form-item
              v-if="pageType == 2"
              label="监测点唯一标识码"
              prop="forms.uuid"
              :rules="[
                {
                  required: true,
                  message: '请输入监测点唯一标识码',
                  trigger: 'blur'
                },
                { validator: CheckComparyNameLength, trigger: 'blur' }
              ]"
            >
              <el-input
                v-model="slotForms.forms.uuid"
                placeholder="监测点唯一标识码"
                clearable
                @blur="checkLabelUuid"
              ></el-input>
              <div :class="{ alarmColor: labelUuidAlarmFlag }">
                {{ labelUuidMessage }}
              </div>
            </el-form-item>
            <el-form-item prop="forms.alarmId" label="温湿度标准">
              <el-select
                v-model="slotForms.forms.alarmId"
                filterable
                clearable
                placeholder="请选择温湿度标准"
              >
                <el-option
                  v-for="item in humitureTree"
                  :key="item.alarmId"
                  :label="item.tempAndHumidityStandardName"
                  :value="item.alarmId"
                ></el-option>
              </el-select>
            </el-form-item>
          </template>
          <template slot="submit">保存</template>
          <template slot="reset">返回</template>
        </e6-form-extend>
      </div>
    </section>
    <!-- content end -->
  </div>
</template>
<script>
import {
  FindVehicleLabelInfoById,
  SaveVehicleLabelInfo,
  CheckNameUniqueData
} from "@/api/base/vehicleLabel";
import { FetchVehicleTree } from "@/api/base/vehicle";
import { FetchHumitureName } from "@/api/systemSetting/humitureStandardSet";
import resizeListener from "_private/mixins/resizeListener";
import { CheckRemarkLength, CheckComparyNameLength } from "@/utils/validation";
export default {
  mixins: [resizeListener],
  data() {
    return {
      breadcrumbs: [
        {
          path: "/home",
          isRedirect: true,
          meta: {
            title: "首页"
          }
        },
        {
          path: "/baseVehicleLabelList",
          isRedirect: true,
          meta: {
            title: "车辆监测点"
          }
        }
      ],
      formExtend: {
        forms: {
          vehicleId: "",
          labelName: "",
          uuid: "",
          alarmId: ""
        },
        extends: []
      },
      labelNameMessage: "",
      labelUuidMessage: "",
      labelNameAlarmFlag: false,
      labelUuidAlarmFlag: false,
      editState: false,
      CheckRemarkLength: CheckRemarkLength,
      CheckComparyNameLength: CheckComparyNameLength,
      loadingState: false,
      vehicleTreeList: [],
      idList: [],
      isFirstLoad: true,
      humitureTree: []
    };
  },
  computed: {
    pageType() {
      return this.$route.query.pageType ? this.$route.query.pageType : "1";
    },
    pageTitle() {
      const pageTitle =
        this.pageType === "1" ? "车辆监测点新增" : "车辆监测点修改";
      return pageTitle;
    },
    id() {
      return this.$route.query.id;
    }
  },
  created() {
    this.FetchHumitureName();
    let breadcrumb = {
      path: "/systemSettingDataDictionaryMaintenanceEdit",
      isRedirect: false,
      meta: {
        title: this.pageTitle
      }
    };
    this.breadcrumbs.push(breadcrumb);
    //初始化区位树

    if (this.pageType !== "1") {
      this.FindVehicleLabelInfoById({ labelId: this.id });
      this.editState = true;
    } else {
      this.initVehicleTree();
    }
  },
  mounted() {
    let idStr = this.$route.query.vehicleIds;
    if (idStr) {
      this.idList = idStr.split(",");
    }
  },
  methods: {
    // 获取温湿度标准下拉Tree
    FetchHumitureName() {
      FetchHumitureName()
        .then(response => {
          if (response.result && Array.isArray(response.result)) {
            this.humitureTree = response.result;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    /**
     * 校验监测点名称唯一性
     */
    checkLabelName() {
      if (
        this.formExtend.forms.labelName &&
        this.formExtend.forms.labelName.indexOf(" ") == -1
      ) {
        CheckNameUniqueData({
          vehicleId: this.formExtend.forms.vehicleId,
          labelName: this.formExtend.forms.labelName,
          labelId: this.id
        }).then(response => {
          if (response.code == 0) {
            if (response.message) {
              this.labelNameAlarmFlag = true;
              this.labelNameMessage = response.message;
            }
          } else {
            this.labelNameAlarmFlag = false;
            this.labelNameMessage = response.message;
          }
        });
      }
    },
    //校验唯一码唯一性
    checkLabelUuid() {
      if (
        this.formExtend.forms.uuid &&
        this.formExtend.forms.uuid.indexOf(" ") == -1
      ) {
        CheckNameUniqueData({
          vehicleId: this.formExtend.forms.vehicleId,
          uuid: this.formExtend.forms.uuid,
          labelId: this.id
        }).then(response => {
          if (response.code == 0) {
            if (response.message) {
              this.labelUuidAlarmFlag = true;
              this.labelUuidMessage = response.message;
            }
          } else {
            this.labelUuidAlarmFlag = false;
            this.labelUuidMessage = response.message;
          }
        });
      }
    },
    //初始化区位树
    initVehicleTree() {
      FetchVehicleTree()
        .then(response => {
          if (response.result && Array.isArray(response.result)) {
            this.vehicleTreeList = response.result;
            this.$nextTick(() => {
              this.$refs.vehicleSelect.setSelectList(this.idList);
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleSelectOrganization(val) {
      const orgArr = val.map(v => v.id);
      this.formExtend.forms.vehicleId = orgArr.join(",");
      if (this.formExtend.forms.vehicleId) {
        this.$refs["vehicleIdElement"].clearValidate();
      }
    },
    //设置勾选
    setNodeCheck(idArr) {
      if (idArr.length > 0 && idArr[0] > 0) {
        this.$nextTick(() => {
          this.$refs.vehicleTreeSelect.setSelectList(idArr);
        });
      } else {
        this.$nextTick(() => {
          this.$refs.vehicleTreeSelect.cleanSelectAll();
        });
      }
    },
    // 修改冷藏车监测点数据时，先获取冷藏车监测点数据信息
    FindVehicleLabelInfoById(response) {
      FindVehicleLabelInfoById(response)
        .then(response => {
          this.formExtend.forms = Object.assign({}, response.result);
          this.idList.push(response.result.vehicleId);
          this.initVehicleTree();
        })
        .catch(error => {
          console.log(error);
        });
    },

    // 新增，修改冷藏车监测点数据
    SaveVehicleLabelInfo(response) {
      SaveVehicleLabelInfo(response)
        .then(response => {
          this.submitCallback(response);
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 新增冷藏车监测点信息完成时的回调函数
    submitCallback(response) {
      let type = response.code === 1 ? "success" : "error";
      let message = response.message;
      this.$message({
        showClose: true,
        message: message,
        type: type,
        duration: 2000,
        onClose: () => {
          if (type === "success") {
            this.$router.push({
              path: "/baseVehicleLabelList",
              query: { refreshportion: true }
            });
          }
          this.loadingState = false;
        }
      });
    },
    // 提交
    handleSubmitForm(e) {
      if (e) {
        if (!this.labelNameAlarmFlag && !this.labelUuidAlarmFlag) {
          this.loadingState = true;
          this.SaveVehicleLabelInfo(Object.assign({}, this.formExtend.forms));
        }
      } else {
        return;
      }
    },
    // 取消
    handleResetForm() {
      this.$router.push("/baseVehicleLabelList");
    }
  }
};
</script>

<style lang="scss" scoped>
.uuidWidth {
  margin-top: -25px;
}
.alarmColor {
  margin-bottom: -21px;
  margin-top: 10px;
  font-size: 12px;
  color: #f56c6c;
}
.page-view {
  height: 100%;
}
.title-section {
  padding: 15px 20px 10px;
}
.content-section {
  overflow: auto;
}
.content-section {
  .form-wrapper {
    padding-top: 20px;
    margin: 0 20px;
    background-color: #fff;
  }
}
/deep/ .e6-from--column-2 {
  .el-input {
    width: 300px;
  }
  .el-textarea__inner {
    width: 500px;
  }
}

/deep/ .el-form-item__content {
  line-height: 1px;
}
.linkSpan {
  display: block;
  float: right;
  margin-left: 310px;
  top: -15px;
  position: relative;
}
</style>
